<template>
  <div class="monitor-list">
    <div class="listTop flex_bc">
      <div class="child1">广播名称</div>
      <div class="child3">操作</div>
    </div>
    <div class="scroll-box">
      <ul>
        <li class="flex_bc" v-for="item in list" :key="item">
          <div class="child1">设备{{ item }}</div>
          <div class="child3">
            <el-link :underline="false" type="primary" style="color: #00ffa2">
              播放
            </el-link>
            <span class="_span"></span>
            <el-link :underline="false" type="warning" @click="open">
              编辑
            </el-link>
            <span class="_span"></span>
            <el-link :underline="false" type="danger" @click="del">
              删除
            </el-link>
            <span></span>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="20%"
      :before-close="handleClose"
      append-to-body
    >
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="广播名称：">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    name: 'monitor-list',
    components: {},
    data() {
      return {
        input: '',
        list: [],
        dialogVisible: false,
        form: {
          name: '',
        },
      }
    },
    computed: {
      classOption() {
        return {
          step: 0.2, // 数值越大速度滚动越快
          limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
          hoverStop: true, // 是否开启鼠标悬停stop
          direction: 1, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        }
      },
    },
    created() {
      this.list = Array.from({ length: 30 }, (v, i) => i + 1)
    },
    methods: {
      open() {
        this.dialogVisible = true
      },
      del() {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
          })
          .catch(() => {})
      },
      handleClose(done) {
        done()
      },
    },
  }
</script>
<style lang="scss" scoped>
  .monitor-list {
    @mixin text_style {
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
    .listTop {
      @include text_style;
      background: #303638;
      color: #e6e6e6;
      margin-top: 20px;
    }
    .scroll-box {
      height: 9vh;
      overflow: auto;
    }
    ul {
      li {
        @include text_style;
        color: #fff;
      }
      li:nth-child(even) {
        background: rgba(255, 255, 255, 0.05);
        border-bottom: 1px solid #535556;
        border-top: 1px solid #535556;
      }
    }
    .listTop,
    li {
      div {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .child1 {
      text-align: left;
      padding-left: 20px;
      flex: 0 20%;
    }
    .child2 {
      flex: 0 50%;
      margin: 0 5%;
    }
    .child3 {
      flex: 0 70%;
    }
    ._span {
      display: inline-block;
      width: 2px;
      height: 12px;
      background: #fff;
      margin: 0 8px;
      position: relative;
      top: 2px;
    }
  }
</style>
